import { render, staticRenderFns } from "./share_box.vue?vue&type=template&id=e12b303c&scoped=true&"
import script from "./share_box.vue?vue&type=script&lang=js&"
export * from "./share_box.vue?vue&type=script&lang=js&"
import style0 from "./share_box.vue?vue&type=style&index=0&id=e12b303c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12b303c",
  null
  
)

export default component.exports